<template>
  <div class="side-edit-content p-5">
    <strong class="title-main">{{ $t('views.seller.integrations.config.edit.title') }}</strong>
    <p class="subtitle d-block mt-3 mb-4">
      {{ $t('views.seller.integrations.config.edit.product') }}:
      <strong> {{ editGroupData.product_name }}</strong>
    </p>

    <!-- Exibe URL -->
    <div :class="isInputError('update_url')" @click="removeError('update_url')">
      <strong class="title-medium">{{ $t('views.seller.integrations.config.edit.url.title') }}</strong>
      <div class="d-flex bd-highlight">
        <div class="flex-grow-1 bd-highlight">
          <b-form-group id="fieldset-url" label-for="input-url">
            <b-form-input id="input-url" :placeholder="`Informe a URL do ${integration.name}`" class="form-input" v-model="editGroupUrl" trim></b-form-input>
          </b-form-group>
        </div>
      </div>
      <span class="show-error">
        {{ showError('update_url') }}
        <template v-if="sugestionRedirect.url">
          <br />
          {{ $t('views.seller.integrations.config.edit.url.sugestion_1') }}
          {{ sugestionRedirect.name }}
          {{ $t('views.seller.integrations.config.edit.url.sugestion_2') }}
          <a :href="`/integracoes/${sugestionRedirect.url}`" @click.stop>
            {{ $t('views.seller.integrations.config.edit.url.sugestion_3') }}
            {{ sugestionRedirect.name }}.
          </a>
        </template>
      </span>
    </div>

  </div>
</template>

<script>

import Multiselect from 'vue-multiselect';
import SwitchGroup from '@/components/shared/forms/SwitchGroup';
import CallbackService from '@/services/resources/CallbackService';

export default {
  name: "IntegrationsConfigUpdateTheMembers",
  components: {
    Multiselect,
    SwitchGroup
  },
  props: {
    opendEdit: {
      type: Boolean,
      required: true
    },
    loadingUpdate: {
      type: Boolean,
      required: true
    },
    editGroupLoad: {
      type: Boolean,
      required: true
    },
    integration: {
      type: Object,
      required: true,
      default: () => ({ name: 'The Members' })
    },
    products: {
      type: Object,
      required: true,
      default: () => ({
        value: null,
        items: [
          {
            group: {
              name: '',
            },
            options: [],
          }
        ],
      })
    },
    mountInputError: {
      type: Function,
      required: true
    },
    isInputError: {
      type: Function,
      required: true
    },
    sugestionRedirect: {
      type: Object,
      required: true,
      default: () => ({
        url: null,
        name: null,
      })
    },
    removeError: {
      type: Function,
      required: true
    },
    removeErrors: {
      type: Function,
      required: true
    },
    showError: {
      type: Function,
      required: true
    },
    fetchCallbacks: {
      type: Function,
      required: true
    },
    limitText: {
      type: Function,
      required: true
    },
  },
  data: () => ({
    loadingTest: false,
    editGroupData: {},
    editGroupUrl: '',
  }),
  methods: {
    showEditCallback(data) {

      this.removeErrors([
        'update_url'
      ]);

      this.disableWatcherTest = true;
      this.editGroupData = data;
      this.editGroupUrl = data.url;

      this.$emit('update:opendEdit', true);
      this.$emit('update:editGroupLoad', false);
      this.$emit('update:loadingUpdate', false);
      this.$emit('update:productSelected', data.product_id);
    },
    async updateCallbacks(products) {

      this.$emit('update:loadingUpdate', true);

      try {
        const events = [
          { trigger: 'salePaid' },
          { trigger: 'saleRefunded' },
          { trigger: 'saleChargedback' },
          { trigger: 'contractTrialing' },
          { trigger: 'contractPaid' },
          { trigger: 'contractEnded' },
          { trigger: 'contractCanceled' }
        ];

        const promises = products.map(async (product_id) => {
          return CallbackService.build().update({
            url_base: this.editGroupData.url,
            url: this.editGroupUrl,
            events
          }, `integrations/group/${this.integration.id}/${product_id}`, { suppressErrorNotify: true });
        });

        await Promise.all(promises);

        this.$emit('update:opendEdit', false);
        this.fetchCallbacks();

        const message = products.length > 1 ?
          this.$t('views.seller.integrations.config.toast.update.success.message_multiple') :
          this.$t('views.seller.integrations.config.toast.update.success.message');

        this.$bvToast.toast(message, {
            title: this.$t('views.seller.integrations.config.toast.update.success.title'),
            variant: "success",
            autoHideDelay: 5000,
            appendToast: true,
        });
      }
      catch(err) {
        this.mountInputError(err.response.data, 'update_');
        this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.update.error.message'), {
            title: this.$t('views.seller.integrations.config.toast.update.error.title'),
            variant: "danger",
            autoHideDelay: 5000,
            appendToast: true,
        });
      }
      finally {
        this.$emit('update:loadingUpdate', false);
      }
    },
  }
}
</script>